/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FantaBooster } from '../models/FantaBooster';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FantaBoosterService {
    /**
     * Get Boosters
     * Get all available boosters.
     * @returns FantaBooster Successful Response
     * @throws ApiError
     */
    public static getBooster(): CancelablePromise<Array<FantaBooster>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/fanta_booster/',
        });
    }
}
